import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { primaryColor } from "../../../../assets/styles/colors";
// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
const grid = 8;
const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: '0px',
    margin: `0 ${grid}px 0 0`,
    width: '64px',
    height: '64px',
    // change background colour if dragging
    background: isDragging ? 'lightgreen' : primaryColor + '55',
    // styles we need to apply on draggables
    ...draggableStyle,
});
const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? 'lightblue' : primaryColor + '55',
    display: 'flex',
    padding: grid,
    overflow: 'auto',
});
const getId = (i, index) => i.id || i.key || i.url || index.toString();
export const OrderPhotos = ({ useItems, setItems, onClick, parent: Parent = Fragment }) => {
    const items = useItems();
    if (items.length === 0)
        return _jsx(_Fragment, {}, void 0);
    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        setItems(reorder(items, result.source.index, result.destination.index));
    };
    // Normally you would want to split things out into separate components.
    // But in this example everything is just done in one place for simplicity
    return (_jsx(Parent, { children: _jsx(DragDropContext, { onDragEnd: onDragEnd, children: _jsx(Droppable, { droppableId: "droppable", direction: "horizontal", children: (provided, snapshot) => (_jsxs("div", { ref: provided.innerRef, style: getListStyle(snapshot.isDraggingOver), ...provided.droppableProps, children: [items.map((item, index) => (_jsx(Draggable, { draggableId: getId(item, index), index: index, children: (provided, snapshot) => (_jsx("div", { ref: provided.innerRef, ...provided.draggableProps, ...provided.dragHandleProps, style: getItemStyle(snapshot.isDragging, provided.draggableProps.style), children: _jsx("img", { src: item.url, alt: ".", style: { width: '100%', height: '100%' }, onClick: () => { if (onClick)
                                        onClick(index); } }, void 0) }, void 0)) }, getId(item, index)))), provided.placeholder] }, void 0)) }, void 0) }, void 0) }, void 0));
};
//# sourceMappingURL=OrderPhotos.js.map